import React from 'react';
import { Button } from '@components/Button';
import './ShowMoreBtn.scss';

interface ShowMoreBtnProps {
  text: string;
  onClick: () => void;
  showingCountText: string;
  showBtn: boolean;
}

export const ShowMoreBtn = ({ text, onClick, showBtn, showingCountText }: ShowMoreBtnProps) => {
  return (
    <div className='news-and-stories-show-more-container'>
      <p className='font-light-x-lg-lh-140'>{showingCountText}</p>
      {showBtn && (
        <Button
          color='primary'
          text={text}
          className='news-and-stories__next-page-btn'
          onClick={onClick}
        />
      )}
    </div>
  );
};
